import request from "../../../utils/request";

export const getDepartments = '/department/'

export function modifyDepartment(data: any) {
    return request.request({
        url: '/department/',
        method: data.id ? "put" : "post",
        data: data
    })
}

export function deleteDepartment(departmentId: number) {
    return request.request({
        url: '/department/',
        method: 'delete',
        params: {departmentId}
    })
}
